const wave = '\ud83d\udc4b';

export const greeting = `${wave} Hey, there!

If you're interested in working on GIFsmos, come hang out with us at
https://www.github.com/ctlusto/gifsmos.`;

const greet = () => {
  console.log(greeting);
};

export default greet;
